module.exports = "pegasus_template/assets/blocks/column-13-theme3.png";